import { render } from "./WorkspaceModelsView.vue?vue&type=template&id=ea82f716&scoped=true&ts=true"
import script from "./WorkspaceModelsView.vue?vue&type=script&lang=ts"
export * from "./WorkspaceModelsView.vue?vue&type=script&lang=ts"

import "./WorkspaceModelsView.vue?vue&type=style&index=0&id=ea82f716&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea82f716"]])

export default __exports__